import React from 'react'
import type { EnrollmentBannerState } from '../../hooks/useEnrollmentBanner'
import { TrackVisible } from '../../tracking/educatorTracking'
import { UrgencyBanner } from '../UrgencyBanner'

// Sentinel index for above-fold meta UI; content rows occupy 0–9.
const BANNER_ROW_POSITION_INDEX = 10

interface EnrollmentBannersProps {
  /** Resolved banner state from `useEnrollmentBanner()`. */
  banner: EnrollmentBannerState
  /** Forwarded to the banner; `false` when it sits below a fixed nav. */
  withTopOffset?: boolean
}

/**
 * Renders the enrollment-window banner (with its `educatorRowViewed` tracking)
 * when the active window has `lpBanner` copy. Renders nothing otherwise.
 */
export const EnrollmentBanners = ({
  banner,
  withTopOffset = true,
}: EnrollmentBannersProps) => {
  const { showWindowBanner, windowLpBannerMessages, enrollmentWindow } = banner

  if (!showWindowBanner || !windowLpBannerMessages) return null

  return (
    <TrackVisible
      event='educatorRowViewed'
      row_name={`enrollment window banner — ${enrollmentWindow?.windowType}`}
      row_position_index={BANNER_ROW_POSITION_INDEX}
    >
      <UrgencyBanner
        lpBanner={windowLpBannerMessages}
        withTopOffset={withTopOffset}
      />
    </TrackVisible>
  )
}
